import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "d-flex flex-wrap mt-3",
    style: { "gap": "0.75rem" }
};
const _hoisted_2 = ["src", "alt"];
const _hoisted_3 = ["onClick"];
import { computed, nextTick, ref } from 'vue';
import vueFilePond from 'vue-filepond';
import 'filepond/dist/filepond.min.css';
import * as FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import Logger from '../Logger';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MultipleFileUploader',
    props: {
        modelValue: { default: () => [] },
        uploadUrl: { default: '/api/files/upload' },
        folder: { default: 'uploads' },
        accept: { default: 'jpg,jpeg,png,gif,svg,webp,pdf,doc,docx,xls,xlsx,csv,zip,mp3,mp4,vtt,woff' },
        maxFileSize: { default: 5120 },
        maxFiles: { default: null },
        label: { default: "Drop files here or <span class='filepond--label-action'>Browse</span>" }
    },
    emits: ["update:modelValue", "uploaded", "error"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const FilePond = vueFilePond(FilePondPluginFileValidateType);
        const props = __props;
        const emit = __emit;
        const pond = ref(null);
        const files = ref(props.modelValue);
        const uploadDisplayUrls = ref({});
        const acceptedMimeTypes = computed(() => {
            const mimeMap = {
                jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png',
                gif: 'image/gif', svg: 'image/svg+xml', webp: 'image/webp',
                pdf: 'application/pdf', doc: 'application/msword',
                docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                xls: 'application/vnd.ms-excel',
                xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                csv: 'text/csv', zip: 'application/zip',
                mp3: 'audio/mpeg', mp4: 'video/mp4',
                vtt: 'text/vtt', woff: 'font/woff',
            };
            return props.accept.split(',')
                .map(ext => mimeMap[ext.trim()])
                .filter(Boolean)
                .join(', ');
        });
        const pondServer = computed(() => {
            return {
                process: {
                    url: props.uploadUrl,
                    headers: {
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                        Accept: 'application/json'
                    },
                    ondata: (formData) => {
                        formData.append('folder', props.folder);
                        formData.append('allowed_mimes', props.accept);
                        formData.append('max_size', props.maxFileSize);
                        return formData;
                    }
                }
            };
        });
        const removeFile = (index) => {
            const path = files.value[index].path;
            files.value.splice(index, 1);
            delete uploadDisplayUrls[path];
            emit('update:modelValue', [...files.value]);
        };
        const handleUploadSuccess = (error, file) => {
            if (error) {
                emit('error', error.message || 'Failed to upload file');
                Logger.error(error, { context: 'MultipleFileUploader - upload error' });
                return;
            }
            try {
                const payload = JSON.parse(file.serverId);
                if (payload.path && !files.value.includes(payload.path)) {
                    files.value.push(payload);
                    emit('update:modelValue', [...files.value]);
                    emit('uploaded', payload);
                }
            }
            catch (e) {
                emit('error', 'Failed to process upload response');
                Logger.error(e, { response: file?.serverId, context: 'MultipleFileUploader - parse error' });
            }
            nextTick(() => {
                if (pond.value) {
                    pond.value.removeFile(file.id);
                }
            });
        };
        const handleUploadFailure = (error) => {
            emit('error', error?.main || error?.message || 'Failed to upload file');
            Logger.error(error, { context: 'MultipleFileUploader - upload failed' });
        };
        const clear = () => {
            files.value = [];
            if (pond.value) {
                pond.value.removeFiles();
            }
            emit('update:modelValue', []);
        };
        __expose({
            clear
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(_unref(FilePond), {
                    ref_key: "pond",
                    ref: pond,
                    server: pondServer.value,
                    "accepted-file-types": acceptedMimeTypes.value,
                    "label-idle": __props.label,
                    name: "file",
                    "allow-multiple": true,
                    "allow-revert": false,
                    "max-files": __props.maxFiles,
                    onProcessfile: handleUploadSuccess,
                    onProcessfileerror: handleUploadFailure
                }, null, 8, ["server", "accepted-file-types", "label-idle", "max-files"]),
                (files.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files.value, (file, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                class: "position-relative"
                            }, [
                                _createElementVNode("img", {
                                    src: file.url,
                                    class: "rounded border bg-light",
                                    alt: file.path,
                                    style: { "width": "80px", "height": "80px", "object-fit": "cover" }
                                }, null, 8, _hoisted_2),
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-danger btn-sm position-absolute rounded-circle p-0 file-remove-btn",
                                    onClick: ($event) => (removeFile(index)),
                                    title: "Remove"
                                }, [...(_cache[0] || (_cache[0] = [
                                        _createElementVNode("i", { class: "fa fa-times" }, null, -1)
                                    ]))], 8, _hoisted_3)
                            ]));
                        }), 128))
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
